import { ReactNode } from 'react';
import { Redirect } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { useLocation } from 'react-router-dom';
import { rolesPermission } from 'src/utils/permissions';

type AuthGuardProps = {
  children?: ReactNode;
};

const AuthGuard = ({ children }: AuthGuardProps) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const permisson = rolesPermission(user, 0);
  const isImpersonating = localStorage.getItem('isImpersonating') === 'true';

  if (isImpersonating) {
    return <>{children}</>;
  }

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  }

  if (
    location.pathname === '/app/users' &&
    !user.groups.filter((item) => item.name === 'AccountAdmin').length &&
    !permisson
  ) {
    return <Redirect to={'/aw_snap'} />;
  }

  switch (user?.account?.subscription?.status) {
    case 'active':
    case 'trialing':
      return <>{children}</>;
    case 'expired':
    case 'canceled':
      return <Redirect to={{ pathname: '/survey' }} />;
    case 'past_due':
      return <Redirect to={{ pathname: '/pastdue' }} />;
    default:
      return <Redirect to="/aw_snap" />;
  }
};

export default AuthGuard;
